import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';
import {
  SHIMMER_GRADIENT,
  shimmerKeyframes,
} from '../../shared/styles/shimmer';

const shimmer = {
  background: SHIMMER_GRADIENT,
  backgroundSize: '200% 100%',
  animation: '$shimmer 1.4s ease infinite',
  borderRadius: '0.25rem',
};

export default makeStyles(theme => ({
  ...shimmerKeyframes,
  layout: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1rem',
    [theme.breakpoints.up('md')]: {
      display: 'grid',
      columnGap: '1.5rem',
      gridTemplateAreas: `
        "products main"
        "total main"`,
      gridTemplateColumns: '1fr 21.25rem',
      gridTemplateRows: '1fr auto',
      padding: 0,
      gap: 0,
    },
  },
  productsArea: {
    gridArea: 'products',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    minWidth: 0,
  },
  totalArea: {
    gridArea: 'total',
    paddingTop: '0.75rem',
  },
  mainArea: {
    gridArea: 'main',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  headerTitle: {
    ...shimmer,
    width: '10rem',
    height: '2rem',
  },
  headerTag: {
    ...shimmer,
    width: '8rem',
    height: '1.5rem',
    borderRadius: '1.25rem',
  },
  headerCount: {
    ...shimmer,
    width: '6rem',
    height: '0.875rem',
  },
  alert: {
    ...shimmer,
    height: '3rem',
  },
  productLine: {
    ...shimmer,
    height: '0.875rem',
  },
  productLineLong: {
    width: '80%',
  },
  productLineShort: {
    width: '40%',
  },
  totalRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1rem 0.75rem',
    border: `1px solid ${neutral[20]}`,
    borderRadius: '0.5rem',
  },
  totalLabel: {
    ...shimmer,
    width: '8rem',
    height: '0.875rem',
  },
  totalAmount: {
    ...shimmer,
    width: '5rem',
    height: '0.875rem',
  },
  illustration: {
    ...shimmer,
    width: '7.5rem',
    height: '7.5rem',
    alignSelf: 'center',
    borderRadius: '0.5rem',
  },
  clientCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    padding: '1rem',
    border: `1px solid ${neutral[20]}`,
    borderRadius: '0.5rem',
  },
  clientLabel: {
    ...shimmer,
    width: '4rem',
    height: '0.625rem',
  },
  clientName: {
    ...shimmer,
    width: '60%',
    height: '0.875rem',
  },
  bannerText: {
    ...shimmer,
    width: '70%',
    height: '1rem',
    alignSelf: 'center',
  },
}));
